import { Card, Skeleton, Space } from 'antd';
import React from 'react';
import { PageHeaderSkeleton } from "../List";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ResultPageSkeleton = function ResultPageSkeleton(_ref) {
  var _ref$active = _ref.active,
    active = _ref$active === void 0 ? true : _ref$active,
    pageHeader = _ref.pageHeader;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      width: '100%'
    },
    children: [pageHeader !== false && /*#__PURE__*/_jsx(PageHeaderSkeleton, {
      active: active
    }), /*#__PURE__*/_jsx(Card, {
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          padding: 128
        },
        children: [/*#__PURE__*/_jsx(Skeleton.Avatar, {
          size: 64,
          style: {
            marginBlockEnd: 32
          }
        }), /*#__PURE__*/_jsx(Skeleton.Button, {
          active: active,
          style: {
            width: 214,
            marginBlockEnd: 8
          }
        }), /*#__PURE__*/_jsx(Skeleton.Button, {
          active: active,
          style: {
            width: 328
          },
          size: "small"
        }), /*#__PURE__*/_jsxs(Space, {
          style: {
            marginBlockStart: 24
          },
          children: [/*#__PURE__*/_jsx(Skeleton.Button, {
            active: active,
            style: {
              width: 116
            }
          }), /*#__PURE__*/_jsx(Skeleton.Button, {
            active: active,
            style: {
              width: 116
            }
          })]
        })]
      })
    })]
  });
};
export default ResultPageSkeleton;